import React from 'react';
import type { TooltipProps } from 'antd';
import type { StoryMediaPlatform } from 'types/story';
import { DEFAULT_MEDIA_QUERY_PLATFORMS, MQ_SIZES_TEXT_MAP } from 'common/constants';
import Tooltip from 'admin/components/common/Tooltip';
import Text from 'admin/components/common/Text';
import t from 'utils/translate';
import css from './MediaQueryIcon.scss';

type Props = {
	mq: StoryMediaPlatform;
	children: React.ReactNode;
	isDefault: boolean;
	placement?: TooltipProps['placement'];
	align?: TooltipProps['align'];
};

export default function MediaQueryTooltip({ mq, children, isDefault, placement = 'right', align }: Props) {
	const textPostfix = isDefault && mq === DEFAULT_MEDIA_QUERY_PLATFORMS.DESKTOP;
	return (
		<Tooltip
			content={
				<Text
					className={css.tooltip}
					size={Text.size.description}
					text={t(`${MQ_SIZES_TEXT_MAP[mq] || ''}${textPostfix ? '_full' : ''}`)}
				/>
			}
			placement={placement}
			align={align}
			stylePreset="dark-2"
			mouseEnterDelay={0}
			mouseLeaveDelay={0}
			stylesContainer={{ maxWidth: 240 }}
		>
			<span>{children}</span>
		</Tooltip>
	);
}
